import { useState } from "react";
import Steps from "./Steps";
import Toggle from "./Toggle";
import { LOCATION_OPTIONS, isValidRegNum } from "../recordDefaults";

export default function ReturnFlow({
  reg,
  setReg,
  onDone,
  onCancel,
  isSaving = false,
  C,
  DamagesComponent,
  FocalxSectionComponent,
  ConfirmReturnComponent,
  showProcessingSection = false,
}) {
  const [err, setErr] = useState({});
  const [regNumTouched, setRegNumTouched] = useState(false);
  const regNumInvalid = regNumTouched && !isValidRegNum(reg.basicInfo.regNum);
  const steps = [
    { n: 1, l: "Info" },
    { n: 2, l: "Sjekk" },
    { n: 3, l: "Retur" },
    { n: 4, l: "Skader/Focalx" },
    { n: 5, l: "Bekreft" },
  ];
  const v1 = () => {
    setRegNumTouched(true);
    const e = {};
    if (!isValidRegNum(reg.basicInfo.regNum)) e.regNum = 1;
    if (!reg.basicInfo.brand.trim()) e.brand = 1;
    if (!reg.basicInfo.model.trim()) e.model = 1;
    if (!reg.basicInfo.mileage.trim()) e.mileage = 1;
    setErr(e);
    return !Object.keys(e).length;
  };
  const v3 = () => {
    const e = {};
    if (!reg.returnInfo.date) e.date = 1;
    if (!reg.returnInfo.by.trim()) e.by = 1;
    setErr(e);
    return !Object.keys(e).length;
  };
  const next = () => {
    if (reg.step === 1 && !v1()) return;
    if (reg.step === 3 && !v3()) return;
    setErr({});
    setReg({ ...reg, step: reg.step + 1 });
  };
  const back = () => {
    setErr({});
    setReg({ ...reg, step: reg.step - 1 });
  };
  const upd = (f, v) =>
    setReg({ ...reg, basicInfo: { ...reg.basicInfo, [f]: v } });
  const updC = (f, v) =>
    setReg({ ...reg, checklist: { ...reg.checklist, [f]: v } });
  const updR = (f, v) =>
    setReg({ ...reg, returnInfo: { ...reg.returnInfo, [f]: v } });
  const updP = (f, v) =>
    setReg({
      ...reg,
      returnProcessing: {
        ...(reg.returnProcessing || {}),
        [f]: v,
      },
    });

  return (
    <div>
      <Steps steps={steps} cur={reg.step} />
      <div
        className="card"
        style={{ padding: "40px", maxWidth: "800px", margin: "0 auto" }}
      >
        {reg.step === 1 && (
          <div>
            <h2
              style={{ marginTop: 0, marginBottom: "32px", color: C.primary }}
            >
              Grunnleggende informasjon
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "24px",
              }}
            >
              <div>
                <label
                  htmlFor="return-reg-num"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Registreringsnummer *
                </label>
                <input
                  id="return-reg-num"
                  aria-invalid={regNumInvalid}
                  aria-describedby={regNumInvalid ? "return-reg-num-error" : undefined}
                  value={reg.basicInfo.regNum}
                  onChange={(e) => {
                    setRegNumTouched(true);
                    upd("regNum", e.target.value.toUpperCase());
                  }}
                  className="inp"
                  placeholder="AB12345"
                  style={{ borderColor: regNumInvalid ? C.danger : undefined }}
                />
                {regNumInvalid && (
                  <p id="return-reg-num-error" role="alert" style={{ color: C.danger }}>
                    Registreringsnummer må bestå av to bokstaver og fem tall uten mellomrom, for eksempel AB12345.
                  </p>
                )}
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Biltype
                </label>
                <select
                  value={reg.basicInfo.vehicleType}
                  onChange={(e) => upd("vehicleType", e.target.value)}
                  className="inp"
                >
                  <option>Personbil</option>
                  <option>SUV</option>
                  <option>Varebil</option>
                  <option>9-seter eller større</option>
                </select>
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Merke *
                </label>
                <input
                  value={reg.basicInfo.brand}
                  onChange={(e) => upd("brand", e.target.value)}
                  className="inp"
                  placeholder="Toyota"
                  style={{ borderColor: err.brand ? C.danger : undefined }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Modell *
                </label>
                <input
                  value={reg.basicInfo.model}
                  onChange={(e) => upd("model", e.target.value)}
                  className="inp"
                  placeholder="Corolla"
                  style={{ borderColor: err.model ? C.danger : undefined }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Kilometerstand *
                </label>
                <input
                  type="number"
                  value={reg.basicInfo.mileage}
                  onChange={(e) => upd("mileage", e.target.value)}
                  className="inp"
                  placeholder="45000"
                  style={{ borderColor: err.mileage ? C.danger : undefined }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Lokasjon
                </label>
                <select
                  value={reg.basicInfo.location || ""}
                  onChange={(e) => upd("location", e.target.value)}
                  className="inp"
                >
                  <option value="">Velg lokasjon...</option>
                  {LOCATION_OPTIONS.map((location) => (
                    <option key={location} value={location}>
                      {location}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
        {reg.step === 2 && (
          <div>
            <h2
              style={{ marginTop: 0, marginBottom: "32px", color: C.primary }}
            >
              Sjekkliste
            </h2>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <Toggle
                label="Bombrikke/belastet alle passeringer"
                on={reg.checklist.tollTag}
                onChange={(v) => updC("tollTag", v)}
              />
              <Toggle
                label="Reservenøkkel er i kjøretøyet"
                on={reg.checklist.spareKey}
                onChange={(v) => updC("spareKey", v)}
              />
              <Toggle
                label="To dekksett er med kjøretøyet"
                on={reg.checklist.twoTireSets}
                onChange={(v) => updC("twoTireSets", v)}
              />
              <Toggle
                label="Hattehylle/Rollo"
                on={reg.checklist.shelf}
                onChange={(v) => updC("shelf", v)}
              />
              <Toggle
                label="Nødlader"
                on={reg.checklist.emergencyCharger}
                onChange={(v) => updC("emergencyCharger", v)}
              />
              <Toggle
                label="Ladekabel type 2"
                on={reg.checklist.cableType2}
                onChange={(v) => updC("cableType2", v)}
              />
              <Toggle
                label="Full tank"
                on={reg.checklist.tank}
                onChange={(v) => updC("tank", v)}
              />
            </div>
          </div>
        )}
        {reg.step === 3 && (
          <div>
            <h2
              style={{ marginTop: 0, marginBottom: "32px", color: C.primary }}
            >
              Tilbakelevering
            </h2>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Dato *
                </label>
                <input
                  type="date"
                  value={reg.returnInfo.date}
                  onChange={(e) => updR("date", e.target.value)}
                  className="inp"
                  style={{ borderColor: err.date ? C.danger : undefined }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Utfylt av *
                </label>
                <input
                  value={reg.returnInfo.by}
                  onChange={(e) => updR("by", e.target.value)}
                  className="inp"
                  placeholder="Ditt navn"
                  style={{ borderColor: err.by ? C.danger : undefined }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                  }}
                >
                  Notater
                </label>
                <textarea
                  value={reg.returnInfo.notes}
                  onChange={(e) => updR("notes", e.target.value)}
                  className="inp"
                  rows={3}
                  placeholder="Kommentarer..."
                />
              </div>
              {showProcessingSection && (
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "12px",
                      fontWeight: "600",
                    }}
                  >
                    Behandling
                  </label>
                  <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                    <Toggle
                      label="Autoplan ferdig"
                      on={!!reg.returnProcessing?.autoplanChecked}
                      onChange={(v) => updP("autoplanChecked", v)}
                    />
                    <Toggle
                      label="Autofleks ferdig"
                      on={!!reg.returnProcessing?.autofleksChecked}
                      onChange={(v) => updP("autofleksChecked", v)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {reg.step === 4 && (
          <div style={{ display: "grid", gap: "24px" }}>
            <DamagesComponent reg={reg} setReg={setReg} />
            <FocalxSectionComponent reg={reg} setReg={setReg} />
          </div>
        )}
        {reg.step === 5 && <ConfirmReturnComponent reg={reg} />}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "40px",
            paddingTop: "24px",
            borderTop: `1px solid ${C.gray}`,
          }}
        >
          <button onClick={reg.step === 1 ? onCancel : back} className="btn-s">
            {reg.step === 1 ? "Avbryt" : "Tilbake"}
          </button>
          {reg.step < 5 ? (
            <button onClick={next} className="btn-p">
              Neste
            </button>
          ) : (
            <button
              onClick={() => onDone(reg)}
              className="btn-p"
              disabled={isSaving}
              style={isSaving ? { opacity: 0.7, cursor: "not-allowed" } : undefined}
            >
              {isSaving ? "Lagrer..." : "Fullfør"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
